import React, { useState, useEffect } from 'react';
import './App.css';
import Loading from './components/loading';
import Navbar from './components/navbar';
import { Route, Switch, useLocation } from 'react-router-dom';

const Contacts = React.lazy(() => import('./pages/contacts'));
const Education = React.lazy(() => import('./pages/education'));
const Home = React.lazy(() => import('./pages/home/index'));
const Portfolio = React.lazy(() => import('./pages/portfolio'));
const Resume = React.lazy(() => import('./pages/resume'));
const Skills = React.lazy(() => import('./pages/skills'));

const App = () => {
  const [showOtherSections, setShowOtherSections] = useState(false);
  const location = useLocation(); // Detect the current URL

  useEffect(() => {
    if (location.pathname === '/') {
      const timer = setTimeout(() => {
        setShowOtherSections(true);
      }, 2000); // 2 seconds after Home loaded

      return () => clearTimeout(timer);
    } else {
      setShowOtherSections(false); // Other pages, don't show scroll sections
    }
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <React.Suspense fallback={<Loading />}>
        <Switch>
          <Route exact path="/">
            {/* Home page + sections */}
            <Home />
            {showOtherSections && (
              <>
                <section className="section">
                 
                </section>
                <section className="section">
                  <Portfolio />
                </section>
                <section className="section">
                  <Skills />
                </section>
               
              </>
            )}
          </Route>
          {/* Other routes */}
          <Route path="/resume" component={Resume} />
          <Route path="/portfolio" component={Portfolio} />
          <Route path="/skills" component={Skills} />
          <Route path="/education" component={Education} />
          <Route path="/contacts" component={Contacts} />
        </Switch>
      </React.Suspense>
    </>
  );
};

export default App;
